import { Record, Union } from "./fable_modules/fable-library.4.10.0/Types.js";
import { record_type, option_type, class_type, anonRecord_type, union_type, string_type } from "./fable_modules/fable-library.4.10.0/Reflection.js";
import { view as view_1, update as update_1, init as init_1, Msg_$reflection as Msg_$reflection_1, Model_$reflection as Model_$reflection_1 } from "./Main.fs.js";
import { view as view_2, update as update_2, init as init_2, Msg_$reflection as Msg_$reflection_2, Model_$reflection as Model_$reflection_2 } from "./Admin.fs.js";
import { view as view_3, update as update_3, init as init_3, Msg_$reflection as Msg_$reflection_3, Model_$reflection as Model_$reflection_3 } from "./Team.fs.js";
import { view as view_4, update as update_4, init as init_5, Msg_$reflection as Msg_$reflection_4, Model_$reflection as Model_$reflection_4 } from "./Reg.fs.js";
import { view as view_5, update as update_5, init as init_4, Msg_$reflection as Msg_$reflection_5, Model_$reflection as Model_$reflection_5 } from "./Audience.fs.js";
import { User, MainUser, LoginReq, RESP$1_$reflection, User_$reflection, Settings_$reflection } from "../shared/Shared.fs.js";
import { Infra_getPreferableLangugage, Infra_clearQueryString, noCmd, apiCmd, Infra_currentQueryString, Infra_loadSettings, Infra_loadUser, ofInt, Infra_saveSettings, Infra_saveUser, Infra_ApiFactory__UpdateTokens, Infra_ApiFactory__CreateAudApi, Infra_ApiFactory__CreateRegApi, Infra_ApiFactory__CreateTeamApi, Infra_ApiFactory__CreateAdminApi, Infra_ApiFactory__CreateMainApi, Infra_ApiFactory__CreateSecurityApi, Infra_redirect, Infra_ApiFactory_$ctor_3A5B6456 } from "./Common.fs.js";
import { Cmd_map } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { FSharpMap__TryFind } from "./fable_modules/fable-library.4.10.0/Map.js";
import { audienceL10n, regL10n, teamL10n } from "./L10n.fs.js";
import * as react from "react";

export class CurrentPage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["EmptyPage", "MainPage", "AdminPage", "TeamPage", "RegPage", "AudPage", "PrivatePage"];
    }
}

export function CurrentPage_$reflection() {
    return union_type("Root.CurrentPage", [], CurrentPage, () => [[["Item", string_type]], [["Item", Model_$reflection_1()]], [["Item", Model_$reflection_2()]], [["Item", Model_$reflection_3()]], [["Item", Model_$reflection_4()]], [["Item", Model_$reflection_5()]], []]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoginResponse", "Exn", "MainMsg", "AdminMsg", "TeamMsg", "RegMsg", "AudMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("Root.Msg", [], Msg, () => [[["Item", RESP$1_$reflection(anonRecord_type(["RefreshToken", string_type], ["Settings", Settings_$reflection()], ["Token", string_type], ["User", User_$reflection()]))]], [["Item", class_type("System.Exception")]], [["Item", Msg_$reflection_1()]], [["Item", Msg_$reflection_2()]], [["Item", Msg_$reflection_3()]], [["Item", Msg_$reflection_4()]], [["Item", Msg_$reflection_5()]]]);
}

export class Model extends Record {
    constructor(CurrentUser, CurrentSettings, CurrentPage) {
        super();
        this.CurrentUser = CurrentUser;
        this.CurrentSettings = CurrentSettings;
        this.CurrentPage = CurrentPage;
    }
}

export function Model_$reflection() {
    return record_type("Root.Model", [], Model, () => [["CurrentUser", option_type(User_$reflection())], ["CurrentSettings", option_type(Settings_$reflection())], ["CurrentPage", CurrentPage_$reflection()]]);
}

export const apiFactory = Infra_ApiFactory_$ctor_3A5B6456(() => {
    Infra_redirect("/login");
});

export const securityApi = Infra_ApiFactory__CreateSecurityApi(apiFactory);

export const mainApi = Infra_ApiFactory__CreateMainApi(apiFactory);

export const adminApi = Infra_ApiFactory__CreateAdminApi(apiFactory);

export const teamApi = Infra_ApiFactory__CreateTeamApi(apiFactory);

export const regApi = Infra_ApiFactory__CreateRegApi(apiFactory);

export const audApi = Infra_ApiFactory__CreateAudApi(apiFactory);

export function initChildPage(user, settings, cm) {
    const cm_1 = new Model(cm.CurrentUser, settings, cm.CurrentPage);
    switch (user.tag) {
        case 0: {
            const patternInput_1 = init_1(mainApi, user.fields[0]);
            return [new Model(user, cm_1.CurrentSettings, new CurrentPage(1, [patternInput_1[0]])), Cmd_map((Item_1) => (new Msg(2, [Item_1])), patternInput_1[1])];
        }
        case 1: {
            const patternInput_2 = init_2(adminApi, user.fields[0]);
            return [new Model(user, cm_1.CurrentSettings, new CurrentPage(2, [patternInput_2[0]])), Cmd_map((Item_2) => (new Msg(3, [Item_2])), patternInput_2[1])];
        }
        case 2: {
            const patternInput_3 = init_3(teamApi, user.fields[0]);
            return [new Model(user, cm_1.CurrentSettings, new CurrentPage(3, [patternInput_3[0]])), Cmd_map((Item_3) => (new Msg(4, [Item_3])), patternInput_3[1])];
        }
        case 4: {
            const patternInput_4 = init_4(audApi, user.fields[0]);
            return [new Model(user, cm_1.CurrentSettings, new CurrentPage(5, [patternInput_4[0]])), Cmd_map((Item_4) => (new Msg(6, [Item_4])), patternInput_4[1])];
        }
        default: {
            const patternInput = init_5(regApi);
            return [new Model(user, cm_1.CurrentSettings, new CurrentPage(4, [patternInput[0]])), Cmd_map((Item) => (new Msg(5, [Item])), patternInput[1])];
        }
    }
}

export function saveUser(token, refreshToken, user, settings) {
    const value = Infra_ApiFactory__UpdateTokens(apiFactory, token, refreshToken);
    Infra_saveUser(user);
    Infra_saveSettings(settings);
}

export function evaluateLoginReq(query) {
    const qs = (x) => FSharpMap__TryFind(query, x);
    const qi = (x_1) => ofInt(qs(x_1));
    const matchValue = qs("code");
    if (matchValue != null) {
        return new LoginReq(0, [{
            Code: matchValue,
        }]);
    }
    else {
        const matchValue_1 = qs("who");
        const matchValue_2 = qi("quiz");
        const matchValue_3 = qs("token");
        const matchValue_4 = qi("team");
        let matchResult, quizId, token, quizId_1, token_1, quizId_2, token_2, quizId_3, teamId, token_3;
        if (matchValue_1 != null) {
            switch (matchValue_1) {
                case "admin": {
                    if (matchValue_2 != null) {
                        if (matchValue_3 != null) {
                            matchResult = 0;
                            quizId = matchValue_2;
                            token = matchValue_3;
                        }
                        else {
                            matchResult = 4;
                        }
                    }
                    else {
                        matchResult = 4;
                    }
                    break;
                }
                case "reg": {
                    if (matchValue_2 != null) {
                        if (matchValue_3 != null) {
                            matchResult = 1;
                            quizId_1 = matchValue_2;
                            token_1 = matchValue_3;
                        }
                        else {
                            matchResult = 4;
                        }
                    }
                    else {
                        matchResult = 4;
                    }
                    break;
                }
                case "aud": {
                    if (matchValue_2 != null) {
                        if (matchValue_3 != null) {
                            matchResult = 2;
                            quizId_2 = matchValue_2;
                            token_2 = matchValue_3;
                        }
                        else {
                            matchResult = 4;
                        }
                    }
                    else {
                        matchResult = 4;
                    }
                    break;
                }
                case "team": {
                    if (matchValue_2 != null) {
                        if (matchValue_3 != null) {
                            if (matchValue_4 != null) {
                                matchResult = 3;
                                quizId_3 = matchValue_2;
                                teamId = matchValue_4;
                                token_3 = matchValue_3;
                            }
                            else {
                                matchResult = 4;
                            }
                        }
                        else {
                            matchResult = 4;
                        }
                    }
                    else {
                        matchResult = 4;
                    }
                    break;
                }
                default:
                    matchResult = 4;
            }
        }
        else {
            matchResult = 4;
        }
        switch (matchResult) {
            case 0:
                return new LoginReq(1, [{
                    QuizId: quizId,
                    Token: token,
                }]);
            case 1:
                return new LoginReq(3, [{
                    QuizId: quizId_1,
                    Token: token_1,
                }]);
            case 2:
                return new LoginReq(4, [{
                    QuizId: quizId_2,
                    Token: token_2,
                }]);
            case 3:
                return new LoginReq(2, [{
                    QuizId: quizId_3,
                    TeamId: teamId,
                    Token: token_3,
                }]);
            default:
                return void 0;
        }
    }
}

export function isReqForSameUser(req, user) {
    let matchResult, data, usr, data_1, usr_1, data_2, usr_2;
    switch (req.tag) {
        case 0: {
            if (user.tag === 0) {
                matchResult = 0;
            }
            else {
                matchResult = 4;
            }
            break;
        }
        case 1: {
            if (user.tag === 1) {
                matchResult = 1;
                data = req.fields[0];
                usr = user.fields[0];
            }
            else {
                matchResult = 4;
            }
            break;
        }
        case 4: {
            if (user.tag === 4) {
                matchResult = 2;
                data_1 = req.fields[0];
                usr_1 = user.fields[0];
            }
            else {
                matchResult = 4;
            }
            break;
        }
        case 2: {
            if (user.tag === 2) {
                matchResult = 3;
                data_2 = req.fields[0];
                usr_2 = user.fields[0];
            }
            else {
                matchResult = 4;
            }
            break;
        }
        default:
            matchResult = 4;
    }
    switch (matchResult) {
        case 0:
            return true;
        case 1:
            return data.QuizId === usr.QuizId;
        case 2:
            return data_1.QuizId === usr_1.QuizId;
        case 3:
            if (data_2.QuizId === usr_2.QuizId) {
                return data_2.TeamId === usr_2.TeamId;
            }
            else {
                return false;
            }
        default:
            return false;
    }
}

export function init() {
    let settings;
    const cm = new Model(void 0, void 0, new CurrentPage(0, ["Initializing..."]));
    const u = Infra_loadUser();
    const s = Infra_loadSettings();
    const matchValue = evaluateLoginReq(Infra_currentQueryString());
    let matchResult, req_1, settings_1, user_1, req_2, settings_2, user_2;
    if (u != null) {
        if (s != null) {
            if (matchValue == null) {
                matchResult = 2;
                settings_2 = s;
                user_2 = u;
            }
            else if ((settings = s, isReqForSameUser(matchValue, u))) {
                matchResult = 0;
                req_1 = matchValue;
                settings_1 = s;
                user_1 = u;
            }
            else {
                matchResult = 1;
                req_2 = matchValue;
            }
        }
        else if (matchValue != null) {
            matchResult = 1;
            req_2 = matchValue;
        }
        else {
            matchResult = 3;
        }
    }
    else if (matchValue != null) {
        matchResult = 1;
        req_2 = matchValue;
    }
    else {
        matchResult = 3;
    }
    switch (matchResult) {
        case 0:
            return initChildPage(user_1, settings_1, cm);
        case 1:
            return apiCmd(securityApi.login, req_2, (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(1, [Item_1])), cm);
        case 2:
            return initChildPage(user_2, settings_2, cm);
        default: {
            Infra_redirect("/");
            return noCmd(cm);
        }
    }
}

export function update(msg, cm) {
    const matchValue = cm.CurrentPage;
    const matchValue_1 = cm.CurrentUser;
    let matchResult, res, txt, ex, subModel, subMsg, user_1, subModel_1, subMsg_1, user_4, subModel_2, subMsg_2, user_5, subModel_3, subMsg_3, subModel_4, subMsg_4, u;
    switch (matchValue.tag) {
        case 0: {
            switch (msg.tag) {
                case 0: {
                    if (msg.fields[0].Value.tag === 1) {
                        matchResult = 1;
                        txt = msg.fields[0].Value.fields[0];
                    }
                    else {
                        matchResult = 0;
                        res = msg.fields[0].Value.fields[0];
                    }
                    break;
                }
                case 1: {
                    matchResult = 2;
                    ex = msg.fields[0];
                    break;
                }
                default:
                    matchResult = 8;
            }
            break;
        }
        case 1: {
            if (matchValue_1 != null) {
                if (matchValue_1.tag === 0) {
                    if (msg.tag === 2) {
                        matchResult = 3;
                        subModel = matchValue.fields[0];
                        subMsg = msg.fields[0];
                        user_1 = matchValue_1.fields[0];
                    }
                    else {
                        matchResult = 8;
                    }
                }
                else {
                    matchResult = 8;
                }
            }
            else {
                matchResult = 8;
            }
            break;
        }
        case 2: {
            if (matchValue_1 != null) {
                if (matchValue_1.tag === 1) {
                    if (msg.tag === 3) {
                        matchResult = 4;
                        subModel_1 = matchValue.fields[0];
                        subMsg_1 = msg.fields[0];
                        user_4 = matchValue_1.fields[0];
                    }
                    else {
                        matchResult = 8;
                    }
                }
                else {
                    matchResult = 8;
                }
            }
            else {
                matchResult = 8;
            }
            break;
        }
        case 3: {
            if (matchValue_1 != null) {
                if (matchValue_1.tag === 2) {
                    if (msg.tag === 4) {
                        matchResult = 5;
                        subModel_2 = matchValue.fields[0];
                        subMsg_2 = msg.fields[0];
                        user_5 = matchValue_1.fields[0];
                    }
                    else {
                        matchResult = 8;
                    }
                }
                else {
                    matchResult = 8;
                }
            }
            else {
                matchResult = 8;
            }
            break;
        }
        case 4: {
            if (matchValue_1 != null) {
                if (matchValue_1.tag === 3) {
                    if (msg.tag === 5) {
                        matchResult = 6;
                        subModel_3 = matchValue.fields[0];
                        subMsg_3 = msg.fields[0];
                    }
                    else {
                        matchResult = 8;
                    }
                }
                else {
                    matchResult = 8;
                }
            }
            else {
                matchResult = 8;
            }
            break;
        }
        case 5: {
            if (matchValue_1 != null) {
                if (matchValue_1.tag === 4) {
                    if (msg.tag === 6) {
                        matchResult = 7;
                        subModel_4 = matchValue.fields[0];
                        subMsg_4 = msg.fields[0];
                        u = matchValue_1.fields[0];
                    }
                    else {
                        matchResult = 8;
                    }
                }
                else {
                    matchResult = 8;
                }
            }
            else {
                matchResult = 8;
            }
            break;
        }
        default:
            matchResult = 8;
    }
    switch (matchResult) {
        case 0: {
            saveUser(res.Token, res.RefreshToken, res.User, res.Settings);
            if (res.User.tag === 0) {
                Infra_clearQueryString();
            }
            return initChildPage(res.User, res.Settings, cm);
        }
        case 1:
            return noCmd(new Model(cm.CurrentUser, cm.CurrentSettings, new CurrentPage(0, [txt])));
        case 2:
            return noCmd(new Model(cm.CurrentUser, cm.CurrentSettings, new CurrentPage(0, [ex.message])));
        case 3: {
            let user_3;
            let matchResult_1;
            if (subMsg.tag === 4) {
                if (subMsg.fields[0].Value.tag === 0) {
                    matchResult_1 = 0;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    const user_2 = new MainUser(user_1.Sub, user_1.Username, user_1.Name, user_1.PictureUrl, true, user_1.IsPrivate);
                    Infra_saveUser(new User(0, [user_2]));
                    user_3 = user_2;
                    break;
                }
                default:
                    user_3 = user_1;
            }
            const patternInput = update_1(mainApi, user_3, subMsg, subModel);
            return [new Model(new User(0, [user_3]), cm.CurrentSettings, new CurrentPage(1, [patternInput[0]])), Cmd_map((Item) => (new Msg(2, [Item])), patternInput[1])];
        }
        case 4: {
            const patternInput_1 = update_2(adminApi, user_4, subMsg_1, subModel_1);
            return [new Model(cm.CurrentUser, cm.CurrentSettings, new CurrentPage(2, [patternInput_1[0]])), Cmd_map((Item_1) => (new Msg(3, [Item_1])), patternInput_1[1])];
        }
        case 5: {
            const patternInput_2 = update_3(teamApi, user_5, subMsg_2, subModel_2);
            return [new Model(cm.CurrentUser, cm.CurrentSettings, new CurrentPage(3, [patternInput_2[0]])), Cmd_map((Item_2) => (new Msg(4, [Item_2])), patternInput_2[1])];
        }
        case 6: {
            const patternInput_3 = update_4(regApi, subMsg_3, subModel_3);
            return [new Model(cm.CurrentUser, cm.CurrentSettings, new CurrentPage(4, [patternInput_3[0]])), Cmd_map((Item_3) => (new Msg(5, [Item_3])), patternInput_3[1])];
        }
        case 7: {
            const patternInput_4 = update_5(audApi, u, subMsg_4, subModel_4);
            return [new Model(cm.CurrentUser, cm.CurrentSettings, new CurrentPage(5, [patternInput_4[0]])), Cmd_map((Item_4) => (new Msg(6, [Item_4])), patternInput_4[1])];
        }
        default:
            return noCmd(cm);
    }
}

export function view(model, dispatch) {
    let pageHtml;
    const matchValue = model.CurrentPage;
    const matchValue_1 = model.CurrentUser;
    const matchValue_2 = model.CurrentSettings;
    let matchResult, txt, settings, subModel, user, settings_1, subModel_1, user_1, settings_2, subModel_2, user_2, settings_3, subModel_3, user_3, settings_4, subModel_4, user_4;
    switch (matchValue.tag) {
        case 0: {
            if (matchValue_1 == null) {
                if (matchValue_2 == null) {
                    matchResult = 0;
                    txt = matchValue.fields[0];
                }
                else {
                    matchResult = 6;
                }
            }
            else {
                matchResult = 6;
            }
            break;
        }
        case 1: {
            if (matchValue_1 != null) {
                if (matchValue_1.tag === 0) {
                    if (matchValue_2 != null) {
                        matchResult = 1;
                        settings = matchValue_2;
                        subModel = matchValue.fields[0];
                        user = matchValue_1.fields[0];
                    }
                    else {
                        matchResult = 6;
                    }
                }
                else {
                    matchResult = 6;
                }
            }
            else {
                matchResult = 6;
            }
            break;
        }
        case 2: {
            if (matchValue_1 != null) {
                if (matchValue_1.tag === 1) {
                    if (matchValue_2 != null) {
                        matchResult = 2;
                        settings_1 = matchValue_2;
                        subModel_1 = matchValue.fields[0];
                        user_1 = matchValue_1.fields[0];
                    }
                    else {
                        matchResult = 6;
                    }
                }
                else {
                    matchResult = 6;
                }
            }
            else {
                matchResult = 6;
            }
            break;
        }
        case 3: {
            if (matchValue_1 != null) {
                if (matchValue_1.tag === 2) {
                    if (matchValue_2 != null) {
                        matchResult = 3;
                        settings_2 = matchValue_2;
                        subModel_2 = matchValue.fields[0];
                        user_2 = matchValue_1.fields[0];
                    }
                    else {
                        matchResult = 6;
                    }
                }
                else {
                    matchResult = 6;
                }
            }
            else {
                matchResult = 6;
            }
            break;
        }
        case 4: {
            if (matchValue_1 != null) {
                if (matchValue_1.tag === 3) {
                    if (matchValue_2 != null) {
                        matchResult = 4;
                        settings_3 = matchValue_2;
                        subModel_3 = matchValue.fields[0];
                        user_3 = matchValue_1.fields[0];
                    }
                    else {
                        matchResult = 6;
                    }
                }
                else {
                    matchResult = 6;
                }
            }
            else {
                matchResult = 6;
            }
            break;
        }
        case 5: {
            if (matchValue_1 != null) {
                if (matchValue_1.tag === 4) {
                    if (matchValue_2 != null) {
                        matchResult = 5;
                        settings_4 = matchValue_2;
                        subModel_4 = matchValue.fields[0];
                        user_4 = matchValue_1.fields[0];
                    }
                    else {
                        matchResult = 6;
                    }
                }
                else {
                    matchResult = 6;
                }
            }
            else {
                matchResult = 6;
            }
            break;
        }
        default:
            matchResult = 6;
    }
    switch (matchResult) {
        case 0: {
            pageHtml = txt;
            break;
        }
        case 1: {
            pageHtml = view_1((arg) => {
                dispatch(new Msg(2, [arg]));
            }, user, settings, subModel);
            break;
        }
        case 2: {
            pageHtml = view_2((arg_1) => {
                dispatch(new Msg(3, [arg_1]));
            }, user_1, settings_1, subModel_1);
            break;
        }
        case 3: {
            pageHtml = view_3((arg_2) => {
                dispatch(new Msg(4, [arg_2]));
            }, user_2, settings_2, subModel_2, teamL10n(Infra_getPreferableLangugage()));
            break;
        }
        case 4: {
            pageHtml = view_4((arg_3) => {
                dispatch(new Msg(5, [arg_3]));
            }, settings_3, subModel_3, regL10n(Infra_getPreferableLangugage()));
            break;
        }
        case 5: {
            pageHtml = view_5((arg_4) => {
                dispatch(new Msg(6, [arg_4]));
            }, settings_4, subModel_4, user_4, audienceL10n(Infra_getPreferableLangugage()));
            break;
        }
        default:
            pageHtml = "Oops";
    }
    return react.createElement("div", {}, pageHtml);
}

